export const isVisible = (parent, child) => {
    if (!parent || !child) {
        return false;
    }
    return !(child.offsetLeft - parent.offsetLeft > parent.offsetWidth ||
        child.offsetTop - parent.offsetTop > parent.offsetHeight);
};
export const setTabIndex = (node, index) => {
    if (node) {
        node.tabIndex = index;
    }
};
